<template>
  <div>
      <v-card>
        <v-card-title>
            <v-toolbar color="primary" dark>
                <v-toolbar-title aling="center">Importación masiva de Competencias</v-toolbar-title>
            </v-toolbar>
        </v-card-title>
        <v-card-subtitle class="d-flex justify-center">
          
        </v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  accept=".xlsx"
                  label="Ingrese la tabla en excel segun el formato"
                  outlined
                  v-model="chosenFile"
                >
                </v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
            <v-btn dark color="blue" :href="api+'public/EjemploCargaMasivaComObj.xlsx'">Ver Ejemplo</v-btn>
          <v-spacer></v-spacer>
            <v-btn dark color="success" @click="enviar" v-if="datos.length > 0">Guardar</v-btn>
        </v-card-actions>
      </v-card>

      <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
          <v-data-table
            :headers="headers"
            :items="datos"
            :items-per-page="5"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
          </v-data-table>

  </div>
</template>
<script>
import axios from "axios";
import api from "../conf/ruta-base";
import router from '../router';
import store from "../store";
import readXlsxFile from 'read-excel-file'
import moment from "moment";
moment.locale('es');
import swal from 'sweetalert';
export default {
  name: 'excel',
  data() {
    return {
      chosenFile: null, search: '',
      headers: [
        { text: "Nombre", value: "nombre"},
        { text: "Descripcion", value: "descripcion"},
      ],
      datos:[],
      api: null,
    }
  },
  mounted() {
      this.api = api.api
  },
  methods: {
    decodeXlsx(){
      readXlsxFile(this.chosenFile).then((rows) => {
        if(rows[0][0]!='Nombre'){
          swal('','Lo siento no he podido validar el documento, favor verificalo','error')
          return null
        }
        for(let i = 1; i < rows.length; i++){
          let datos = {
            nombre: rows[i][0],
            descripcion: rows[i][1],
            casoexito: rows[i][2],
            resultados: rows[i][3],
            peso: rows[i][4],
          }
          if(this.validar(rows[i]))
            this.datos.push(datos)
        }
      })
    },
    validar(row){
      if(row[0].length < 1 || row[2].length < 1 || row[3].length < 1 || row[4].length < 1)
        return false
      return true
    },
    enviar(){
      axios
        .post(api.api + 'comdic/masivo', this.datos)
        .then(res => {
          this.toast(res.data.c, res.data.mensaje);
          router.push('/competencias')
        })
        .catch(error => {
            console.log(error);
        });
    },
    toast(color, text) {
      var toast = { color, text };
      store.commit("TOAST", toast);
    }
  }, 
  watch: {
    chosenFile(val){
      if(val != undefined){
        this.decodeXlsx()
      }else{
        this.datos = []
      }
    }
  },
}
</script>